
import React, { Fragment } from "react";
import { Button, Dialog, DialogContent, DialogContentText, TextField, DialogActions, DialogTitle, Select, MenuItem, Fade, InputLabel, Tooltip } from '@material-ui/core'
import { getConfigSync } from "../../api"

// Year group tooltips with country equivalents
const YEAR_GROUP_TOOLTIPS = {
    'Year Group A': 'Year Group A - Y9 in England and Wales, Y10 in Northern Ireland, S2 in Scotland or equivalent in your country (and in younger year groups)',
    'Year Group B': 'Year Group B - Y10 in England and Wales, Y11 in Northern Ireland, S3 in Scotland or equivalent in your country',
    'Year Group C': 'Year Group C - Y11 in England and Wales, Y12 in Northern Ireland, S4 in Scotland or equivalent in your country',
    'Year Group D': 'Year Group D - Y12 in England and Wales, Y13 in Northern Ireland, S5 in Scotland or equivalent in your country',
    'Year Group E': 'Year Group E - Y13 in England and Wales, Y14 in Northern Ireland, S6 in Scotland or equivalent in your country'
};
interface Props {
    onSubmit:(name:string, yearGroup:string,password1:string,password2:string,gender:string)=>void
    message:string|null
    name:string
    yearGroup:string
    gender:string
}

interface State {
    password1:string
    password2:string
    name:string
    yearGroup:string
    gender:string
}

export default class StudentDetailsDialog extends React.Component<Props, State> {

    constructor(props:Props) {

        super(props)

        this.state = {
            name:this.props.name,
            yearGroup:this.props.yearGroup,
            gender:this.props.gender,
            password1:'',
            password2:'',
        }
    }

    render() {

        let {name, yearGroup, password1, password2, gender } = this.state
        let passwordsSame = (password1 == password2)
        let canPressAdd = name && yearGroup && password1 && password2 && passwordsSame

        if (getConfigSync().collectGender == true) {
            if (!gender) canPressAdd = false
        } 

        return (
            <div>
            <Dialog open={true} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Student Details</DialogTitle>
                <DialogContent>
                    {/* ugly help? */}
                    {
                        this.props.message &&
                        <Fragment>
                            <div style={{color: 'red'}}>{this.props.message}</div>
                            <br/>
                        </Fragment>
                    }
                    <p>Please enter your name, year group and set a new password to continue.</p>
                    
                    <InputLabel id="name-label">Full name as you wish to appear on certificate (seen by teacher)</InputLabel>
                    <TextField
                        required 
                        label=""
                        value = {name}
                        onChange = {this.onChangeName}
                    />
                    <br/>
                    <br />
                    <InputLabel id="yeargroup-label">Year Group</InputLabel>
                    <Select
                        required
                        label="Year Group"
                        value = {yearGroup}
                        onChange = {this.onChangeYearGroup}
                    >
                        <MenuItem
                            key={"Year Group A"}
                            value={"Year Group A"}>
                            <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group A']} placement="right">
                                <div>Year Group A</div>
                            </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group B"}
                            value={"Year Group B"}>
                            <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group B']} placement="right">
                                <div>Year Group B</div>
                            </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group C"}
                            value={"Year Group C"}>
                            <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group C']} placement="right">
                                <div>Year Group C</div>
                            </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group D"}
                            value={"Year Group D"}>
                            <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group D']} placement="right">
                                <div>Year Group D</div>
                            </Tooltip>
                        </MenuItem>
                        <MenuItem
                            key={"Year Group E"}
                            value={"Year Group E"}>
                            <Tooltip title={YEAR_GROUP_TOOLTIPS['Year Group E']} placement="right">
                                <div>Year Group E</div>
                            </Tooltip>
                        </MenuItem>
                    </Select>
                    { (getConfigSync().collectGender == true) && <Fragment><br/>
                    <br />
                    <InputLabel id="gender-label">Gender</InputLabel>
                    <Select
                        required
                        label="Gender"
                        value = {gender}
                        onChange = {this.onChangeGender}
                    >
                        <MenuItem
                            key={"Male"}
                            value={"Male"}>
                              {"Male"}
                        </MenuItem>
                        <MenuItem
                            key={"Female"}
                            value={"Female"}>
                              {"Female"}
                        </MenuItem>
                        <MenuItem
                            key={"Other"}
                            value={"Other"}>
                              {"Other"}
                        </MenuItem>
                        <MenuItem
                            key={"Prefer not to say"}
                            value={"Prefer not to say"}>
                              {"Prefer not to say"}
                        </MenuItem>
                    </Select></Fragment>}
                     <br/>
                    <TextField
                        required
                        type="password"
                        label="Password"
                        value = {password1}
                        onChange = {this.onChangePassword1}
                    />
                     <br/>
                    <TextField
                        required
                        type="password"
                        label="Retype password"
                        value = {password2}
                        onChange = {this.onChangePassword2}
                    />
                    {
                        <Fade in={!passwordsSame && (password2 != '')}>
                                <div style={{color: 'red'}}>
                                    Passwords are not the same.
                                </div>
                        </Fade>
                    }
                </DialogContent>
                <DialogActions>
                <Button disabled={!canPressAdd} onClick={this.onSubmit} color="secondary">
                    Save
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        );
    }

    onChangeName = (e: any) => {
        this.setState((prevState) => ({ ...prevState, name: e.target.value }))
    }

    onChangeYearGroup = (e: any) => {
        this.setState((prevState) => ({ ...prevState, yearGroup: e.target.value }))
    }

    onChangeGender = (e: any) => {
        this.setState((prevState) => ({ ...prevState, gender: e.target.value }))
    }

    onChangePassword1 = (e: any) => {
        this.setState((prevState) => ({ ...prevState, password1: e.target.value }))
    }

    onChangePassword2 = (e: any) => {
        this.setState((prevState) => ({ ...prevState, password2: e.target.value }))
    }

    onSubmit = () => {
        this.props.onSubmit(this.state.name, this.state.yearGroup,this.state.password1,this.state.password2, this.state.gender)
    }

}

